(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ancestra"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var box=document.querySelector('[data-countdown]');
    if(box){
      var key='an_deadline',end=parseInt(localStorage.getItem(key),10);
      if(!end||isNaN(end)||end<Date.now()){end=Date.now()+3*24*60*60*1000;localStorage.setItem(key,end);}
      var d=box.querySelector('[data-d]'),h=box.querySelector('[data-h]'),m=box.querySelector('[data-m]'),s=box.querySelector('[data-s]');
      var pad=function(n){return(n<10?'0':'')+n;};
      var tick=function(){var t=end-Date.now();if(t<0)t=0;
        d.textContent=pad(Math.floor(t/86400000));h.textContent=pad(Math.floor(t/3600000)%24);
        m.textContent=pad(Math.floor(t/60000)%60);s.textContent=pad(Math.floor(t/1000)%60);};
      tick();setInterval(tick,1000);
    }
    document.querySelectorAll('.an-tabs__nav').forEach(function(nav){
      nav.addEventListener('click',function(e){
        var btn=e.target.closest('button[data-tab]');if(!btn)return;
        var id=btn.getAttribute('data-tab'),scope=nav.parentElement;
        nav.querySelectorAll('button').forEach(function(b){b.classList.toggle('is-active',b===btn);});
        scope.querySelectorAll('.an-panel').forEach(function(p){p.classList.toggle('is-active',p.getAttribute('data-panel')===id);});
      });
    });

    var gal=document.querySelector('[data-gallery]');
    if(gal){
      var main=gal.querySelector('[data-galmain]');
      var thumbs=Array.prototype.slice.call(gal.querySelectorAll('[data-galthumb]'));
      var cur=0;
      var show=function(i){
        cur=(i+thumbs.length)%thumbs.length;
        var img=thumbs[cur].querySelector('img');
        main.src=img.src; main.alt=img.alt;
        thumbs.forEach(function(t,n){t.classList.toggle('is-active',n===cur);});
      };
      thumbs.forEach(function(t,n){t.addEventListener('click',function(){show(n);});});
      var prev=gal.querySelector('[data-galprev]'),next=gal.querySelector('[data-galnext]');
      if(prev)prev.addEventListener('click',function(){show(cur-1);});
      if(next)next.addEventListener('click',function(){show(cur+1);});
    }

    var form=document.querySelector('.an-form');
    if(form){
      var qtyf=form.querySelector('[data-qty]'), idf=form.querySelector('[data-id]');
      var priceEl=document.querySelector('[data-price]'), ctaEl=form.querySelector('[data-cta-price]');
      var sync=function(){
        var r=form.querySelector('input[name="an_plan"]:checked');
        if(!r){ return; }
        if(qtyf){ qtyf.value=r.getAttribute('data-qty')||'1'; }
        var v=r.getAttribute('data-variant'); if(idf&&v){ idf.value=v; }
        var t=r.getAttribute('data-total');
        if(t){ if(priceEl){ priceEl.textContent='€'+t; } if(ctaEl){ ctaEl.textContent='€'+t; } }
      };
      form.querySelectorAll('input[name="an_plan"]').forEach(function(r){ r.addEventListener('change',sync); });
      sync();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
